import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { useKnownAvailableParams, useNavigate } from '@change-corgi/core/react/router';
// import { useTracking } from '@change-corgi/core/react/tracking';

import { useDashboardEndorsements } from '../../../../../../hooks/useDashboardEndorsements';

export function EndorsementsBanner(): JSX.Element | null {
	const { slug } = useKnownAvailableParams<{ slug: string }>();
	const navigate = useNavigate();
	// const track = useTracking();
	const isEndorsementsEnabled = useDashboardEndorsements();

	if (!isEndorsementsEnabled.data.isEnabled) {
		return null;
	}

	const handleAddEndorsementClick = () => {
		// void track('starter_dashboard_endorsements_banner_add_click');
		navigate(`/p/${slug}/dashboard/endorsements/add`);
	};

	return (
		<div className="" data-testid="endorsements-banner">
			<Button
				variant="secondary-solid"
				size="small"
				onClick={handleAddEndorsementClick}
				data-testid="add-endorsement-button"
				data-qa="add-endorsement-button"
			>
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.banner.add_button" />
			</Button>
		</div>
	);
}
